import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import styles from "./styles";
import Draggable from "react-draggable";
import { Grid, Typography } from "@material-ui/core";

const DraggableLabel = (props) => {
  const {
    showDraggable,
    onDragStart,
    onDragEnd,
    onDragUpdate,
    setDraggableLabel,
    label,
    currentQuestion,
    dragStarted,
    classes,
    image,
    left,
    displayLabel,
  } = props;

  return (
    <Draggable
      onDrag={onDragUpdate}
      onStart={() => setDraggableLabel(label)}
      onStop={onDragEnd}
      position={{ x: 0, y: 0 }}
    >
      <Grid container className={classes.dragableDiv}>
        <Grid container className={classes.shadowDiv} />

        <Grid container className={classes.textContainer}>
          <Typography className={classes.text} dangerouslySetInnerHTML={{__html: displayLabel }} />
        </Grid>
        {/* <img src={image} alt="PriceLabel" style={{ [left && "left"]: left }} className={classes.labelIcon}/> */}
      </Grid>

    </Draggable>
  );
};

export default withStyles(styles)(DraggableLabel);
